"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INIT_REDUCER = undefined;
exports.init = init;
exports.initIfNeeded = initIfNeeded;
exports.is = is;

var _utils = require("./../utils");

var INIT_REDUCER = exports.INIT_REDUCER = 'shared.initReducer';

/**
 * Inicializace shared store.
 * @param area oblast
 * @param konkrétní store
 */
function init(area, store) {
    return {
        type: INIT_REDUCER,
        area: area,
        store: store
    };
}

function initIfNeeded(area, redudcer) {
    return function (dispatch, getState) {
        var currentStore = (0, _utils.storeFromArea)(getState(), area, false);
        if (currentStore === null) {
            var newStore = redudcer();
            dispatch(init(area, newStore));
        }
    };
}

/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */
function is(action) {
    switch (action.type) {
        case INIT_REDUCER:
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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